import React from "react";
import _ from "underscore";
import PropTypes from "prop-types";
import Radio from "../forms/radio";

const FilterPopoverRadio = ({ filterKey, options, onChange, value }) => {
  return _.map(options, option => {
    return (
      <Radio
        key={option.key}
        className="et--filter-option"
        name={option.name}
        value={option.key}
        checked={value === option.key}
        onChange={() => onChange(filterKey, option.key)}
      >
        {option.name}
      </Radio>
    );
  });
};

FilterPopoverRadio.propTypes = {
  filterKey: PropTypes.string,
  options: PropTypes.array,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

export default FilterPopoverRadio;
